import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as DE from '../locales/DE.json';
import * as EN from '../locales/EN.json';
import * as FR from '../locales/FR.json';
import * as IT from '../locales/IT.json';

const debugLogStyle = 'background: aliceBlue; color: steelBlue';

export const resources = {
  DE: {
    translation: DE,
  },
  EN: {
    translation: EN,
  },
  FR: {
    translation: FR,
  },
  IT: {
    translation: IT,
  },
} as const;

i18next
  .use(initReactI18next)
  .init({
    lng: 'EN', // default language
    resources,
    fallbackLng: {
      CH: ['DE'],
      AT: ['DE'], // DE is also spoken in AT and CH
      default: ['EN'],
    },
  })
  .catch(() => {
    // biome-ignore lint: <explanation>
    console.warn('%c [i18n] i18next could not be initialized.', debugLogStyle);
  });

export default i18next;
